"use client";

import React from "react";
import { Check, Minus, Sparkles, Crown, Star, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const plans = [];
const features = [];
export default function IntegrationCost() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224358" id="přehledný-ceník" className="bg-background text-foreground py-24 px-4 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-primary/5 blur-[120px] rounded-full opacity-40" />
        <div className="absolute bottom-0 right-1/4 w-[600px] h-[600px] bg-primary/10 blur-[150px] rounded-full opacity-30" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_100%)]" />
      </div>

      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="text-center mb-20 max-w-3xl mx-auto">
          <Badge variant="outline" className="mb-6 border-primary/30 text-primary bg-primary/5 font-sans tracking-[0.2em] uppercase text-[10px] py-1 px-4 rounded-full">
            <Sparkles className="w-3 h-3 mr-2" />
            Exkluzivní Nabídka
          </Badge>
          <h2 className="text-4xl md:text-6xl font-bold font-serif mb-8 tracking-tight text-foreground">
            Umění <span className="text-primary italic">Intimity</span>
          </h2>
          <p className="text-lg text-muted-foreground font-sans leading-relaxed">
            Vyberte si rituál, který nejlépe odpovídá vašim touhám. Každá minuta v salonu SENSU je věnována vašemu absolutnímu potěšení v prostředí nejvyššího luxusu.
          </p>
        </div>

        <div ref={ref} className={cn("transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <div className="bg-card/40 backdrop-blur-md border border-primary/10 rounded-3xl shadow-4xl overflow-hidden">
            <Table className="w-full border-collapse">
              <TableHeader>
                <TableRow className="hover:bg-transparent border-b border-primary/10">
                  
                  {plans.map((plan, i) => <TableHead key={plan.id} data-index={i} className={cn("w-1/4 p-8 text-center align-top relative transition-colors duration-500", plan.popular ? "bg-primary/5" : "")}>
                      {plan.popular && <div className="absolute -top-0 left-0 w-full h-1 bg-primary" />}
                      
                    </TableHead>)}
                </TableRow>
              </TableHeader>
              <TableBody>
                {features.map((feature, i) => <TableRow key={feature.name} data-index={i} className="hover:bg-primary/5 border-b border-primary/5 transition-colors group">
                    
                    
                    
                    <TableCell className="p-6 text-center text-muted-foreground font-sans">
                      {typeof feature.enterprise === "boolean" ? feature.enterprise ? <Check className="mx-auto text-primary size-5" /> : <Minus className="mx-auto text-muted-foreground/20 size-5" /> : <span className="text-sm">{feature.enterprise}</span>}
                    </TableCell>
                  </TableRow>)}
                <TableRow className="hover:bg-transparent border-none">
                  
                  {plans.map((plan, i) => <TableCell key={`cta-${plan.id}`} data-index={i} className={cn("p-8 text-center align-top", plan.popular ? "bg-primary/5" : "")}>
                      <Button variant={plan.buttonVariant} className={cn("w-full rounded-full font-sans tracking-widest uppercase text-[10px] py-6 transition-all duration-300", plan.popular ? "shadow-xl shadow-primary/20 bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-[1.02]" : "border-primary/30 text-primary hover:bg-primary/10")} asChild>
                        <Link to="/ContactPage">{plan.buttonText}</Link>
                      </Button>
                    </TableCell>)}
                </TableRow>
              </TableBody>
            </Table>
          </div>
          
          <div className="mt-12 text-center">
            <p className="text-sm text-muted-foreground italic font-serif">
              * Všechny ceny jsou konečné. Pro individuální požadavky nás neváhejte kontaktovat.
            </p>
          </div>
        </div>
      </div>
    </section>;
}